import { Tooltip } from "@alpacahq/ui";
import { Badge, clsx } from "@alpacahq/ui/old";

export interface MarketStatusBadgePresentationProps {
  isLoading?: boolean;
  icon: JSX.Element;
  tooltip: string;
  firstText: string;
  secondText: string;
  emphasizeFirstText?: boolean;
  emphasizeSecondText?: boolean;
}

const standardStyles = "text-neutral-700 font-normal";
const emphasizeStyles = "text-neutral-800 font-medium";

export const MarketStatusBadgePresentation = ({
  isLoading,
  icon,
  tooltip,
  firstText,
  secondText,
  emphasizeFirstText = false,
  emphasizeSecondText = false,
}: MarketStatusBadgePresentationProps) => {
  if (isLoading) {
    return <div className="h-6 w-32 animate-pulse rounded-full bg-gray-200" />;
  }

  return (
    <Badge
      variant="v2/gray"
      className={clsx("flex items-center gap-1 border-none bg-transparent")}
    >
      <Tooltip content={tooltip}>{icon}</Tooltip>
      <span
        className={clsx(
          "text-sm",
          emphasizeFirstText ? emphasizeStyles : standardStyles,
        )}
      >
        {firstText}
      </span>
      <span
        className={clsx(
          "text-sm",
          emphasizeSecondText ? emphasizeStyles : standardStyles,
        )}
      >
        {secondText}
      </span>
    </Badge>
  );
};
